import React from 'react';
import LessonSubheader from '@/components/shared/NewLessonOverview/LessonSubheader';
import { SlideGroup } from '@/types/api/LessonOverview';
import SlideGroupCard from './Cards/Card/SlideGroupCard';

interface SlideGroupSectionProps {
  icon: 'eye' | 'pencil';
  slideGroups: SlideGroup[];
  subheaderNumber?: number;
  title: string;
}

const SlideGroupSection = ({ icon, slideGroups, subheaderNumber, title }: SlideGroupSectionProps) => (
  <LessonSubheader
    subheaderNumber={subheaderNumber}
    title={title}
  >
    <section className="tw-mr-20">
      {slideGroups.map(slideGroup => (
        <SlideGroupCard
          key={slideGroup.id}
          icon={icon}
          slideGroup={slideGroup}
        />
      ))}
    </section>
  </LessonSubheader>
);

export default SlideGroupSection;
